import { Helmet } from 'react-helmet-async';
import { MuiTheme } from 'config/theme';
import * as googleHelpers from 'lib/googleHelpers';
// tslint:disable-next-line
import 'static/reset.css';
// tslint:disable-next-line
import 'static/fonts/fonts.css';

export const Head = () => (
    <Helmet>
        {import.meta.env.NODE_ENV === 'production' && (
            <script
                async
                src={`https://www.googletagmanager.com/gtag/js?id=${import.meta.env.GA_TRACKING_ID}`}
            />
        )}
        {import.meta.env.NODE_ENV === 'production' && (
            <script type="text/javascript">{googleHelpers.getGoogleTagsManagerScript()}</script>
        )}
        {import.meta.env.NODE_ENV === 'production' && (
            <script type="text/javascript">{googleHelpers.getGoogleOptimizeScript()}</script>
        )}
        {import.meta.env.NODE_ENV === 'production' && (
            <style type="text/javascript">{googleHelpers.getAntiFlickerStyles()}</style>
        )}
        <script
            src={`https://maps.googleapis.com/maps/api/js?key=${
                import.meta.env.GOOGLE_API_KEY
            }&libraries=geometry,drawing,places`}
        />
        <title>Pepper Management Console</title>
        <meta name="title" content="Pepper Management Console" />
        {/* PWA primary color */}
        <meta name="theme-color" content={MuiTheme.palette.primary.main} />
        <meta charSet="utf-8" />
    </Helmet>
);
